/* Urban47 — bloco de confiança (snippets/product-trust-box.liquid): contador até o PRÓXIMO ENVIO.
   Um relógio só por página, para todas as cópias do bloco (produto, visualização rápida, destaque da home). */
(function () {
  'use strict';
  if (window.U47Trust) { window.U47Trust.scan(); return; }

  /* ===================== FÁCIL DE ALTERAR ===================== */
  /* Horários de envio por dia da semana (horário de Brasília). */
  var ENVIOS = {
    1: ['10:00', '16:00'], /* segunda */
    2: ['10:00', '16:00'], /* terça   */
    3: ['10:00', '16:00'], /* quarta  */
    4: ['10:00', '16:00'], /* quinta  */
    5: ['10:00', '16:00'], /* sexta   */
    6: ['10:00'],          /* sábado  */
    0: []                  /* domingo: sem envio */
  };
  /* Dias SEM envio (feriados nacionais), no formato AAAA-MM-DD. */
  var SEM_ENVIO = [
    '2026-01-01', '2026-04-03', '2026-04-21', '2026-05-01', '2026-09-07',
    '2026-10-12', '2026-11-02', '2026-11-15', '2026-11-20', '2026-12-25',
    '2027-01-01', '2027-03-26', '2027-04-21', '2027-05-01', '2027-09-07',
    '2027-10-12', '2027-11-02', '2027-11-15', '2027-11-20', '2027-12-25'
  ];
  /* ============================================================ */

  var FUSO_MIN = -180; /* America/Sao_Paulo = UTC-3 (sem horário de verão desde 2019) */
  var DIAS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  var MIN = 60000, DIA = 86400000;
  var ajuste = 0; /* hora do servidor - hora do aparelho (ms); 0 enquanto não medir ou se falhar */

  function agora() { return Date.now() + ajuste; }
  function dois(n) { n = Math.max(0, n); return n < 10 ? '0' + n : String(n); }

  /* Próximo envio depois de `ms` (instante real). Trabalha no "relógio de parede" de Brasília. */
  function proximoEnvio(ms) {
    var local = ms + FUSO_MIN * MIN;
    var inicioDoDia = Math.floor(local / DIA) * DIA;
    for (var i = 0; i < 15; i++) {
      var dia = new Date(inicioDoDia + i * DIA);
      var chave = dia.getUTCFullYear() + '-' + dois(dia.getUTCMonth() + 1) + '-' + dois(dia.getUTCDate());
      if (SEM_ENVIO.indexOf(chave) !== -1) continue;
      var horarios = ENVIOS[dia.getUTCDay()] || [];
      for (var j = 0; j < horarios.length; j++) {
        var hm = horarios[j].split(':');
        var h = Number(hm[0]), m = Number(hm[1] || 0);
        var alvoLocal = inicioDoDia + i * DIA + (h * 60 + m) * MIN;
        if (alvoLocal > local) {
          var quando = i === 0 ? 'hoje' : (i === 1 ? 'amanhã' : DIAS[dia.getUTCDay()]);
          return {
            alvo: alvoLocal - FUSO_MIN * MIN,
            /* \u00a0 = espaço que não quebra: "10h de hoje." nunca se separa nem sobra sozinho na última linha */
            frase: 'Pagamento aprovado agora sai no envio das ' + h + 'h' + (m ? dois(m) : '') + '\u00a0de\u00a0' + quando + '.'
          };
        }
      }
    }
    return null;
  }

  var atual = null;
  function escrever(el, texto) { if (el && el.textContent !== texto) el.textContent = texto; }

  function pintar() {
    var t = agora();
    if (!atual || t >= atual.alvo) atual = proximoEnvio(t);
    var blocos = document.querySelectorAll('[data-u47-trust]');
    if (!atual) { for (var k = 0; k < blocos.length; k++) blocos[k].setAttribute('data-u47-ready', 'sem-envio'); return; }
    var seg = Math.max(0, Math.ceil((atual.alvo - t) / 1000));
    var hh = dois(Math.floor(seg / 3600)), mm = dois(Math.floor((seg % 3600) / 60)), ss = dois(seg % 60);
    for (var i = 0; i < blocos.length; i++) {
      var b = blocos[i];
      escrever(b.querySelector('[data-u47-hours]'), hh);
      escrever(b.querySelector('[data-u47-minutes]'), mm);
      escrever(b.querySelector('[data-u47-seconds]'), ss);
      escrever(b.querySelector('[data-u47-shipping-message]'), atual.frase);
      if (b.getAttribute('data-u47-ready') !== '1') b.setAttribute('data-u47-ready', '1');
    }
  }

  function ciclo() {
    pintar();
    /* alinha no começo do próximo segundo: a troca de alvo e de frase acontece no segundo exato */
    setTimeout(ciclo, 1000 - (agora() % 1000) + 8);
  }

  /* Relógio do aparelho errado: confere com a hora do servidor da loja, uma vez, depois que a página aparece.
     Falhou? Vale o relógio do aparelho. Só corrige diferença acima de 90 s. */
  function conferirHora() {
    try {
      var t0 = Date.now();
      fetch('/cart.js', { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
        var t1 = Date.now(); var servidor = Date.parse(r.headers.get('date') || '');
        if (!servidor) return;
        var diferenca = servidor + 500 - (t0 + t1) / 2;
        if (Math.abs(diferenca) > 90000) { ajuste = diferenca; atual = null; pintar(); }
      }).catch(function () {});
    } catch (e) {}
  }

  window.U47Trust = { scan: pintar, proximoEnvio: proximoEnvio };
  ciclo();
  if (document.readyState === 'complete') setTimeout(conferirHora, 1500);
  else window.addEventListener('load', function () { setTimeout(conferirHora, 1500); });
})();
